// Polyfills for older browsers compatibility
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import 'whatwg-fetch'; // Fetch API polyfill for older browsers

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {ThemeProvider} from "./ThemeContext";
import './theme.css';
import './chwala-ux-fixes.css';
import {UPDATE_READY_EVENT} from './shared/services/VersionService';

// Set page title from runtime configuration
if (window.APP_CONFIG && window.APP_CONFIG.PAGE_TITLE) {
  document.title = window.APP_CONFIG.PAGE_TITLE;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App/>
    </ThemeProvider>
  </React.StrictMode>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Activate only when the user requests the new version.
    if (registration.waiting) {
      // console.log('Service worker update available:', registration);
      window.dispatchEvent(new Event(UPDATE_READY_EVENT));
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
